const getVisibleChannelIndex = ({
  offsetX,
  scrollUnit,
}: {
  offsetX: number;
  scrollUnit: number;
}): number => Math.round(offsetX / scrollUnit);

export default getVisibleChannelIndex;
